import RestService from '@/modules/backend/RestService';
import { CreateAccountData } from '@/modules/backend/Dto/CreateAccountData';
import { Account } from '@/modules/backend/Entities/Account';
import { plainToClass } from 'class-transformer';
import { EditAccountData } from '@/modules/backend/Dto/EditAccountData';

export default class Accounts {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async Create(payload: CreateAccountData): Promise<Account> {
    const result = await this.rest.post('/api/v1/account/', payload);

    return plainToClass(Account, result);
  }

  public async Edit(payload: EditAccountData): Promise<Account> {
    const result = await this.rest.put('/api/v1/account', payload);

    return plainToClass(Account, result);
  }

  public async List(locationId: number): Promise<Account[]> {
    try {
      const items = await this.rest.get<unknown[]>(`/api/v1/location/${locationId}/accounts`);
      return plainToClass(Account, items);
    } catch {
      return [];
    }
  }

  public async GetOne(accountId: number): Promise<Account> {
    const account = await this.rest.get(`/api/v1/account/${accountId}`);

    return plainToClass(Account, account);
  }

  public async Remove(accountId: number): Promise<void> {
    await this.rest.delete(`/api/v1/account/${accountId}`);
  }
}
